










import Vue from "vue";
import HelloWorld from "./components/HelloWorld.vue";
import Cabecalho from "./components/Cabecalho.vue";
import Rodape from "./components/Rodape.vue";
import router from "./router";
import { EventBus } from "./main";

import { Component } from "vue-property-decorator";

@Component({
  components: {
    cabecalho: Cabecalho,
    rodape: Rodape,
  },
})
export default class App extends Vue {
  mounted() {
    router.beforeEach(async (to, from, next) => {
      EventBus.$emit("mudouRota", next);
      await EventBus.$on("navegar", () => {
        next();
      });
    });
  }
}
